import { render, staticRenderFns } from "./DataGroupConsentDetail.vue?vue&type=template&id=491e7c7e&scoped=true&"
import script from "./DataGroupConsentDetail.vue?vue&type=script&lang=js&"
export * from "./DataGroupConsentDetail.vue?vue&type=script&lang=js&"
import style0 from "./DataGroupConsentDetail.vue?vue&type=style&index=0&id=491e7c7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491e7c7e",
  null
  
)

export default component.exports